<template>
  <div class="color-swatches">
    <div
      v-for="c in colorOptions"
      :key="c"
      :class="['_swatch', { '-selected': c === selectedColor }]"
      :style="swatchStyle(c)"
      @click="$emit('select', c)"
    >
      A
    </div>
  </div>
</template>

<script setup>
import { optionColor } from 'shared/constants.json';
import { optionTextColorMap } from 'shared/lib/color-map';

const props = defineProps({
  selectedColor: {
    type: String,
    default: 'default',
  },
});

defineEmits(['select']);

const colorOptions = optionColor.all;

const swatchStyle = (c) => {
  const textColor = optionTextColorMap[c] || optionTextColorMap.default;
  return {
    color: textColor,
    borderColor: c === props.selectedColor ? textColor : undefined,
  };
};
</script>

<style scoped lang="scss">
.color-swatches {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.2rem;
  justify-items: center;
}

._swatch {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: .4rem;
  border: 1.5px solid $border-color;
  font-weight: $font-weight-bold;
  font-size: $font-size-5;
  cursor: pointer;

  &:hover {
    background-color: $hover-color;
  }
}
</style>
